import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initFlowbite } from 'flowbite';

export default function AegovDlsProvider() {
  const location = useLocation();

  useEffect(() => {
    // Wait for React to finish DOM rendering/paint before initializing Flowbite
    const timer = setTimeout(() => {
      initFlowbite();
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}
